var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: { form: _vm.form, rules: _vm.rules, width: "800px" },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 22 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SettingBaseDataCodeRule.ruleCode"),
                    prop: "ruleCode",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.ruleCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "ruleCode", $$v)
                      },
                      expression: "form.ruleCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SettingBaseDataCodeRule.ruleName"),
                    prop: "ruleName",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.ruleName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "ruleName", $$v)
                      },
                      expression: "form.ruleName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SettingBaseDataCodeRule.table.tenant"),
                    prop: "tenantId",
                  },
                },
                [
                  _c("BjSelectTenant", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.form.tenantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "tenantId", $$v)
                      },
                      expression: "form.tenantId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }